namespace TabAurous.OMS {
    export interface DiscountingPolicyRow {
        DiscountId?: number;
        Code?: string;
        Name?: string;
        CompanyId?: number;
        Details?: DiscountingPolicyDetailsRow[];
    }

    export namespace DiscountingPolicyRow {
        export const idProperty = 'DiscountId';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'OMS.DiscountingPolicy';
        export const lookupKey = 'OMS.DiscountingPolicy';

        export function getLookup(): Q.Lookup<DiscountingPolicyRow> {
            return Q.getLookup<DiscountingPolicyRow>('OMS.DiscountingPolicy');
        }
        export const deletePermission = 'Masters:DiscountingPolicy:Delete';
        export const insertPermission = 'Masters:DiscountingPolicy:Add';
        export const readPermission = 'Masters:DiscountingPolicy:View';
        export const updatePermission = 'Masters:DiscountingPolicy:Edit';

        export declare const enum Fields {
            DiscountId = "DiscountId",
            Code = "Code",
            Name = "Name",
            CompanyId = "CompanyId",
            Details = "Details"
        }
    }
}
